<template>
  <div class="ns-frame">
    <div class="logo"></div>
    <iframe frameborder="0" src="http://itemcdn.cellz.cn/items/player/10195/index.html"></iframe>
    <div class="operate-bar">
      <div class="item">
        <a href="javascript:void(0);" @click="reload" class="home"></a>
      </div>
      <div class="item" v-if="countryLanguage.length>0">
        <a href="javascript:void(0);" class="language"></a>
        <div class="drop">
          <div class="arrow"></div>
          <div class="drop-c">
            <a href="javascript:void(0);" v-for="(item,index) in countryLanguage" @click="setLocal(item)">{{item.name}}</a>
            <!--<a href="javascript:void(0);">EN</a>-->
          </div>
        </div>
      </div>
      <!-- <div class="item">
         <a href="javascript:void(0);" class="language"></a>
         <div class="drop">
           <div class="arrow"></div>
           <div class="drop-c">
             <a href="javascript:void(0);">中文中文中文</a>
             <a href="javascript:void(0);">EN</a>
           </div>
         </div>
       </div>-->
      <div class="item">
        <a href="javascript:void(0);" class="music"></a>
      </div>
    </div>
    <div class="contact global">
      <a href="javascript:void(0);" class="wx"></a>
      <a href="javascript:void(0);" class="fa"></a>
      <a href="javascript:void(0);" class="tw"></a>
      <a href="javascript:void(0);" class="ins"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "main-frame",
  props: {
    country: {
      required: true,
      type: String,
      default: ''
    },
    countryCode: {
      required: true,
      type: String,
      default: ''
    },
    countryLanguage: {
      required: true,
      type: Array,
      default: []
    }
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {
    setTimeout(function () {

    }, 100);
  },
  destroyed() {

  }
}
</script>

<style scoped>

iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  background: transparent;
  border: 0px;
}

</style>

